import { cloneDeep } from 'lodash';

import { TeamSettings } from 'utils/team';

export const patchTeamSettings = (
  originalSettings: TeamSettings,
  patchSettings: TeamSettings | undefined
): TeamSettings => ({
  brand: {
    // Override the original colors with the new ones if they exist without merging
    colors: cloneDeep(
      patchSettings?.brand?.colors ?? originalSettings?.brand?.colors
    ),
  },
});
